export function PageSkeleton() {
  return (
    <div className="px-4 pt-6">
      <div className="skeleton h-40 rounded-3xl mb-6" />
      <div className="grid grid-cols-2 gap-3">
        <div className="skeleton" style={{ aspectRatio: '0.71 / 1' }} />
        <div className="skeleton" style={{ aspectRatio: '0.71 / 1' }} />
        <div className="skeleton" style={{ aspectRatio: '0.71 / 1' }} />
        <div className="skeleton" style={{ aspectRatio: '0.71 / 1' }} />
      </div>
    </div>
  );
}

export default PageSkeleton;
